import React, { useRef, useEffect } from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import DataTableInput from '../../../Input/input';
import descriptionClasses from './description.css';
import columnsClasses from '../columns.css';

const Description = ({ focus, active, disabled, elementFocused, editableDescription, isRuleFound, row, handleDescription, handleUndoDescription }) => {
    const descriptionInput = useRef(null);

    useEffect(() => {
        if (!disabled && descriptionInput.current) {
            if (active)
                descriptionInput.current.focus();
            else
                descriptionInput.current.blur();
        }
    }, [active, descriptionInput])

    const undoDescription = () => {
        handleUndoDescription(row);
    }

    const onBlurEditableDescription = (e) => {
        handleDescription(e.target.value, row);
    }

    return (
        <Tooltip title={row.Description}>
            {(editableDescription !== true || isRuleFound(row)) ? <span>{row.Description}</span>
            : <div>
                <DataTableInput
                    value={row.Description || ''}
                    onFocus={elementFocused}
                    className={descriptionClasses.descriptionInput}
                    onBlur={(e) => {
                        onBlurEditableDescription(e);
                    }}
                    elementRef={descriptionInput}
                    disabled={disabled}
                    style={(row.isDescriptionUpdated && row.OriginalDescription !== row.Description && !disabled) ? { paddingRight: 10, boxSizing: 'border-box' } : {}}
                />
                {row.isDescriptionUpdated && row.OriginalDescription !== row.Description && !disabled ?
                    <i className="fas fa-undo" onClick={() => undoDescription()} style={{ float: 'right', position: 'absolute', right: '0px', top: '35%' }}></i> : ''}
            </div>}
        </Tooltip>
    );
}

export default Description;


// WEBPACK FOOTER //
// ./src/components/TransactionList/Columns/Description/description.js